// экспорт MAX_PAGE_SIZE из api не работает в этом файле
export const getPersonsObjectsQueryParams = { size: 9999, sort: 'desc' };
